import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  SmsBatchListResponse,
  SmsBatchSummary,
} from "@/api/backofficeRest/generated/model"
import { QueryResult } from "@/api/utils/types"

export interface ISmsBatchService {
  listBatches(): QueryResult<SmsBatchSummary[]>
}

class SmsBatchServiceClass implements ISmsBatchService {
  listBatches(): QueryResult<SmsBatchSummary[]> {
    return useQuery({
      ...BackofficeRestQueries.smsBatches.list(),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data: SmsBatchListResponse): SmsBatchSummary[] =>
        data?.batches ?? [],
      showSnackbarError: true,
      meta: {
        errorMessage: "Failed to load SMS batches",
      },
    })
  }
}

export const SmsBatchService = new SmsBatchServiceClass()
